import { deleteDybrBlog } from '@/api/profiles';
import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import RadioGroup from '@/components/FormElements/RadioGroup';
import TextField from '@/components/FormElements/TextField';
import { ActionButton } from '@/components/Shared/Buttons';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { doLogoutThunk } from '@/store/user/thunks/doLogoutThunk';
import theme from '@/styles/DybrTheme';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const options = {
  KEEP: 'keep',
  ANON: 'anonimize',
  DELETE: 'delete'
};

const commentOptions = [
  {
    label: 'оставить комментарии',
    value: options.KEEP,
    radioValue: options.KEEP
  },
  {
    label: 'оставить комментарии от анонимного профиля',
    value: options.ANON,
    radioValue: options.ANON
  },
  {
    label: 'удалить все комментарии',
    value: options.DELETE,
    radioValue: options.DELETE
  }
];

export function DeleteBlogSettings() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const [token, setToken] = useTokenState();

  const profile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );

  const [deleteOption, setDeleteOption] = useState('');
  const [title, setTitle] = useState('');
  const isConfirmed =
    title === profile.blogTitle &&
    Object.values(options).includes(deleteOption);

  const changeOptions = (_, id) => {
    setDeleteOption(id);
  };

  const handleClick = async () => {
    await deleteDybrBlog({
      profileId: profile.id,
      comments: deleteOption,
      token
    });
    dispatch(doLogoutThunk(setToken));
    navigate('/');
  };

  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Удалить дневник</h4>
          <p>Удалить дневник и профиль</p>
        </SettingSectionTitle>
        <Settings>
          <p>
            Удаление дневника это необратимое действие. Если вы точно уверены,
            что хотите удалить дневник, введите в поле <strong>название</strong>{' '}
            своего дневника.
          </p>
          <br />
          <TextField
            label="название дневника"
            value={title}
            onChange={e => setTitle(e.target.value)}
            touched
          />
          <br />
          <RadioGroup
            title="что делать с комментариями в чужих дневниках"
            name="deletingCommentsOptions"
            checked={deleteOption}
            onCheck={changeOptions}
            items={commentOptions}
          />
          <br />
          <ActionButton
            onClick={handleClick}
            disabled={!isConfirmed}
            style={{ backgroundColor: theme.brand }}
          >
            Удалить дневник
          </ActionButton>
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}
